(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afro-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal') || null;
      if(this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-2-2"]) return;
  try {
    
/* Swipe carousel JS if needed (use Flickity or CSS scroll-snap if possible) */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foundations-check-inline"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fc-inline-trigger]');
    if (!trigger) return;

    window.dispatchEvent(new CustomEvent('foundation-check:open', {
      detail: { entryPoint: 'popup' }
    }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foundations-check"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('foundation-check-app')) return;

  var THEME_ORDER = ['energy', 'switched_on', 'digestion', 'recovery'];
  var THEME_LABEL = {
    energy: 'Energy',
    switched_on: 'Getting switched on',
    digestion: 'Digestion',
    recovery: 'Recovery'
  };

  var QUESTIONS = [
    {
      id: 'q1',
      text: 'In a normal week, roughly how many different plants do you eat? Count vegetables, fruit, beans, nuts, seeds and wholegrains.',
      options: [
        { key: 'a', label: 'Fewer than ten', support: { digestion: 2, recovery: 2 } },
        { key: 'b', label: 'Around ten to twenty', support: { digestion: 1, recovery: 1 } },
        { key: 'c', label: 'Twenty or more', support: {} }
      ]
    },
    {
      id: 'q2',
      text: 'In a normal week, how much of what you eat is cooked from scratch?',
      options: [
        { key: 'a', label: 'Most of it', support: {} },
        { key: 'b', label: 'About half', support: { digestion: 1, energy: 1 } },
        { key: 'c', label: 'Not much, I’m usually grabbing something', support: { digestion: 2, energy: 2, recovery: 1 } }
      ]
    },
    {
      id: 'q3',
      home: 'energy',
      text: 'How does your energy usually hold up across the day?',
      options: [
        { key: 'a', label: 'Steady from start to finish', denial: 'energy' },
        { key: 'b', label: 'Fine until the afternoon', home: { energy: 2 } },
        { key: 'c', label: 'I’m running on fumes by mid afternoon', home: { energy: 4 } },
        { key: 'd', label: 'It’s up and down all day', home: { energy: 2 }, support: { switched_on: 1 } }
      ]
    },
    {
      id: 'q4',
      home: 'switched_on',
      text: 'How long does it take you to feel properly switched on in the morning?',
      options: [
        { key: 'a', label: 'I’m on it quickly', denial: 'switched_on' },
        { key: 'b', label: 'An hour or so', home: { switched_on: 2 } },
        { key: 'c', label: 'Honestly, sometimes not until lunchtime', home: { switched_on: 4 } }
      ]
    },
    {
      id: 'q5',
      home: 'digestion',
      text: 'How often does your digestion feel comfortable and settled?',
      options: [
        { key: 'a', label: 'Almost always', denial: 'digestion' },
        { key: 'b', label: 'Most of the time, with the odd off day', home: { digestion: 2 } },
        { key: 'c', label: 'Less often than I’d like', home: { digestion: 4 } }
      ]
    },
    {
      id: 'q6',
      home: 'recovery',
      text: 'By the end of a busy week, how do you usually feel?',
      options: [
        { key: 'a', label: 'Still going, I bounce back quickly', denial: 'recovery' },
        { key: 'b', label: 'Tired, but nothing a weekend doesn’t fix', home: { recovery: 2 } },
        { key: 'c', label: 'Properly wiped out, and it takes me a while to come back', home: { recovery: 4 } }
      ]
    },
    {
      id: 'q7',
      text: 'On a typical weekday, how often do you eat a meal within two hours of waking?',
      options: [
        { key: 'a', label: 'Most mornings', support: {} },
        { key: 'b', label: 'Two or three mornings a week', support: { switched_on: 1, energy: 1 } },
        { key: 'c', label: 'Rarely, I usually wait until lunch', support: { switched_on: 2, energy: 2 } }
      ]
    },
    {
      id: 'q8',
      text: 'Have you taken something daily for your health before?',
      routing: true,
      options: [
        { key: 'a', label: 'Yes, and I felt a real difference' },
        { key: 'b', label: 'Yes, but I never noticed anything', routes: 'formula' },
        { key: 'c', label: 'Yes, but I couldn’t stick with it', routes: 'consistency' },
        { key: 'd', label: 'No, this would be a first' }
      ]
    }
  ];

  var THEME_COPY = {
    energy: {
      icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.62814 12.6736H8.16918C6.68545 12.6736 5.94358 12.6736 5.62736 12.1844C5.31114 11.6953 5.61244 11.0138 6.21504 9.65083L8.02668 5.55323C8.57457 4.314 8.84852 3.69438 9.37997 3.34719C9.91142 3 10.5859 3 11.935 3L14.0244 3C15.6632 3 16.4826 3 16.7916 3.53535C17.1007 4.0707 16.6942 4.78588 15.8811 6.21623L14.8092 8.10188C14.405 8.81295 14.2029 9.16849 14.2057 9.45952C14.2094 9.83775 14.4105 10.1862 14.7354 10.377C14.9854 10.5239 15.3927 10.5239 16.2074 10.5239C17.2373 10.5239 17.7523 10.5239 18.0205 10.7022C18.3689 10.9338 18.5513 11.3482 18.4874 11.7632C18.4382 12.0826 18.0918 12.4656 17.399 13.2317L11.8639 19.3523C10.7767 20.5545 10.2331 21.1556 9.86807 20.9654C9.50303 20.7751 9.67833 19.9822 10.0289 18.3962L10.7157 15.2896C10.9826 14.082 11.1161 13.4782 10.7951 13.0759C10.4741 12.6736 9.85877 12.6736 8.62814 12.6736Z" stroke="#FDFAF9" stroke-width="1.5" stroke-linejoin="round"/>
            </svg>`,
      heading: 'Energy: the afternoon dip',
      body: 'Your answers suggest energy becomes harder to maintain as the day goes on. Iron, riboflavin, vitamin B6 and vitamin B12 all contribute to normal energy-yielding metabolism.',
      nutrients: ['Iron', 'riboflavin', 'vitamin B6', 'vitamin B12']
    },
    switched_on: {
      heading: 'Getting switched on: a slow start to the day',
      body: 'Your answers suggest it takes a while before you feel properly switched on in the morning. Zinc contributes to normal cognitive function.',
      nutrients: ['Zinc']
    },
    digestion: {
      icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.48457 2C9.72845 3.49019 10.4411 4.57432 12.475 3.87202C16.6773 2.42099 19.9986 6.8491 19.9986 10.8C19.9986 14.7765 17.353 18 14.0895 18H13.0247C10.492 18 8.27593 19.6321 7.45312 22M6.0058 2V2.77557C6.0058 6.57844 11.4279 9.38737 9.63736 13.1999C8.92581 14.715 4.89483 17.2931 4 22M14 7C14.9576 7.29708 15.711 8.04937 16 9" stroke="#FDFAF9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>`,
      heading: 'Digestion: digestion that isn’t always settled',
      body: 'Your answers suggest digestion doesn’t always feel as settled as you’d like. Fibre, variety, hydration and eating patterns all shape how it feels from one day to the next.',
      nutrients: []
    },
    recovery: {
      heading: 'Recovery: running on empty by the end of the week',
      body: 'Your answers suggest a busy week takes more out of you than you’d like. Iron, vitamin C and vitamin B12 all contribute to the reduction of tiredness and fatigue.',
      nutrients: ['Iron', 'vitamin C', 'vitamin B12']
    }
  };

  var FORMULA_BLOCK = 'This one is worth sitting with. If you’ve taken something daily and felt nothing at all, that doesn’t automatically mean you did it wrong. Too many formulas are generic and built for the broadest possible audience. It’s the realisation this whole brand started from: the problem wasn’t you. It was the formula.';
  var CONSISTENCY_LINE = 'And if the sticking point has been keeping it up, that’s worth naming too. One scoop, once a day, is designed to be easier to keep up than juggling several separate products.';
  var MEDICAL_NOTE = 'This isn’t medical advice. If something’s been bothering you for a while, it’s worth a conversation with your GP.';

  var BRIDGE_STANDARD = 'Food first, always. But if you’d rather not think about it every day, that’s what we make. One daily scoop of Afro Health\u00AE Daily Greens gives you the full recommended daily amount of every nutrient named above: {nutrients}. Vegan, caffeine free, and naturally flavoured with apple and kiwi. Sweetened with stevia leaf, no sugar.';
  var BRIDGE_FALLBACK = 'Food comes first. But keeping good nutrition consistent every day isn’t always easy. Afro Health\u00AE Daily Greens brings vitamins, minerals, greens and digestive support together in one daily scoop. Vegan, caffeine free, and naturally flavoured with apple and kiwi. Sweetened with stevia leaf, no sugar.';

  var SOLID_GROUND_HEADER = 'You’re building on solid ground';
  var SOLID_GROUND_BODY = 'Your answers suggest you’ve already got several useful habits in place. The opportunity at your end of the scale is less about fixing an obvious gap and more about keeping good nutrition consistent when life gets busy.';

  var GAPS_HEADER = 'Here’s where your foundation might have gaps';
  var INTRO_TWO = 'Your answers point to two areas that may be under more pressure during a typical week. Nothing here is a diagnosis. It’s a picture of where the everyday gaps tend to open up.';
  var INTRO_ONE = 'Your answers point to one area that may be under more pressure during a typical week. Nothing here is a diagnosis. It’s a picture of where the everyday gaps tend to open up.';

  var CAPTURE_GAPS = {
    heading: 'That’s the picture. Here’s what to do about it.',
    body: 'The food sources for each of your areas and the habits that help most. There’s more than fits comfortably on this screen. Give us your name and email and we’ll send it straight over.'
  };
  var CAPTURE_SOLID = {
    heading: 'You’re in good shape. Here’s how to stay there.',
    body: 'The habits worth protecting when the week gets busy, and the everyday food sources behind them. There’s more than fits comfortably on this screen. Give us your name and email and we’ll send it straight over.'
  };

  // ---------- result_title / result_summary for Klaviyo: built from the EXACT on-screen copy ----------
  function firstSentence(str) {
    if (!str) return '';
    var match = str.match(/^[^.!?]*[.!?]/);
    return match ? match[0].trim() : str.trim();
  }

  function getResultCopy(result) {
    if (result.resultType === 'solid_ground') {
      return {
        title: SOLID_GROUND_HEADER,
        summary: SOLID_GROUND_BODY
      };
    }

    var introSentence = firstSentence(result.shown.length === 2 ? INTRO_TWO : INTRO_ONE);
    var themeSentences = result.shown.map(function (t) {
      return firstSentence(THEME_COPY[t].body);
    });

    return {
      title: GAPS_HEADER,
      summary: [introSentence].concat(themeSentences).join(' ')
    };
  }

  function scoreAnswers(answers) {
    var themes = {};
    THEME_ORDER.forEach(function (t) {
      themes[t] = { home: 0, total: 0, denied: false };
    });

    QUESTIONS.forEach(function (q) {
      var chosenKey = answers[q.id];
      if (!chosenKey) return;
      var opt = q.options.filter(function (o) { return o.key === chosenKey; })[0];
      if (!opt) return;

      if (opt.denial) {
        themes[opt.denial].denied = true;
      }
      if (opt.home) {
        Object.keys(opt.home).forEach(function (t) {
          themes[t].home += opt.home[t];
          themes[t].total += opt.home[t];
        });
      }
      if (opt.support) {
        Object.keys(opt.support).forEach(function (t) {
          themes[t].total += opt.support[t];
        });
      }
    });

    var survivors = THEME_ORDER.filter(function (t) { return !themes[t].denied; });

    var eligible = survivors.filter(function (t) {
      var s = themes[t];
      return s.home >= 2 && (s.total >= 3 || s.home === 4);
    });

    eligible.sort(function (a, b) {
      var sa = themes[a], sb = themes[b];
      if (sb.total !== sa.total) return sb.total - sa.total;
      if (sb.home !== sa.home) return sb.home - sa.home;
      return THEME_ORDER.indexOf(a) - THEME_ORDER.indexOf(b);
    });

    var shown = eligible.slice(0, 2);
    var resultType = shown.length >= 1 ? 'gaps' : 'solid_ground';

    var q8Opt = QUESTIONS[7].options.filter(function (o) { return o.key === answers.q8; })[0];
    var formulaFlag = !!(q8Opt && q8Opt.routes === 'formula');
    var consistencyFlag = !!(q8Opt && q8Opt.routes === 'consistency');

    return {
      themes: themes,
      shown: shown,
      resultType: resultType,
      formulaFlag: formulaFlag,
      consistencyFlag: consistencyFlag
    };
  }

  function buildNutrientList(shownThemes) {
    var seen = {};
    var list = [];
    shownThemes.forEach(function (t) {
      (THEME_COPY[t].nutrients || []).forEach(function (n) {
        if (!seen[n]) { seen[n] = true; list.push(n); }
      });
    });
    return list;
  }

  function joinNutrients(list) {
    if (list.length === 0) return '';
    if (list.length === 1) return list[0];
    return list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
  }

  var FoundationCheckApp = /** @class */ (function () {
    function FoundationCheckApp(el) {
      this.el = el;
      this.answers = {};
      this.currentIndex = -1;
      this.entryPoint = 'overlay';
      this.startedAt = null;
      this.completed = false;
      this.result = null;

      this.overlay = el.querySelector('[data-fc-overlay]');
      this.progressWrap = el.querySelector('[data-fc-progress]');
      this.progressBar = el.querySelector('[data-fc-progress-bar]');
      this.screens = {
        start: el.querySelector('[data-fc-screen="start"]'),
        intro: el.querySelector('[data-fc-screen="intro"]'),
        question: el.querySelector('[data-fc-screen="question"]'),
        result: el.querySelector('[data-fc-screen="result"]')
      };

      this.companyId = el.dataset.klaviyoCompanyId;
      this.listId = el.dataset.klaviyoListId;
      this.exitIntentDelay = parseInt(el.dataset.exitIntentDelay, 10) || 20;
      this.mobileScrollDepth = parseInt(el.dataset.mobileScrollDepth, 10) || 45;
      this.holdoutPercent = parseInt(el.dataset.holdoutPercent, 10) || 10;
      this.cooldownDays = parseInt(el.dataset.cooldownDays, 10) || 30;

      this.deviceClass = window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
      this.visitorId = this.getOrCreateVisitorId();
      this.isNewVisitor = this.markVisitorSeen();
      this.utm = this.captureUtm();
      this.landingPage = this.captureLandingPage();

      this.buildProgressSegments();
      this.bind();
      this.assignHoldout();
      this.initTriggers();
    }

    FoundationCheckApp.prototype.buildProgressSegments = function () {
      this.progressBar.innerHTML = '';
      for (var i = 0; i < QUESTIONS.length; i++) {
        var seg = document.createElement('span');
        seg.className = 'fc-progress-segment';
        this.progressBar.appendChild(seg);
      }
      this.progressSegments = this.progressBar.querySelectorAll('.fc-progress-segment');
    };

    FoundationCheckApp.prototype.updateProgressSegments = function (index) {
      this.progressSegments.forEach(function (seg, i) {
        seg.classList.toggle('is-filled', i <= index);
      });
    };
    FoundationCheckApp.prototype.getOrCreateVisitorId = function () {
      try {
        var id = localStorage.getItem('fc_visitor_id');
        if (!id) {
          id = 'v_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
          localStorage.setItem('fc_visitor_id', id);
        }
        return id;
      } catch (e) {
        return 'v_unknown';
      }
    };

    FoundationCheckApp.prototype.markVisitorSeen = function () {
      try {
        var seen = localStorage.getItem('fc_visitor_seen');
        if (!seen) {
          localStorage.setItem('fc_visitor_seen', '1');
          return true;
        }
        return false;
      } catch (e) {
        return true;
      }
    };

    FoundationCheckApp.prototype.captureUtm = function () {
      var fallback = { utm_source: null, utm_medium: null, utm_campaign: null };
      try {
        var stored = sessionStorage.getItem('fc_utm');
        if (stored) return JSON.parse(stored);

        var params = new URLSearchParams(window.location.search);
        var utm = {
          utm_source: params.get('utm_source') || null,
          utm_medium: params.get('utm_medium') || null,
          utm_campaign: params.get('utm_campaign') || null
        };
        sessionStorage.setItem('fc_utm', JSON.stringify(utm));
        return utm;
      } catch (e) {
        return fallback;
      }
    };

    FoundationCheckApp.prototype.captureLandingPage = function () {
      try {
        var stored = sessionStorage.getItem('fc_landing_page');
        if (stored) return stored;
        var landing = window.location.pathname + window.location.search;
        sessionStorage.setItem('fc_landing_page', landing);
        return landing;
      } catch (e) {
        return window.location.pathname;
      }
    };

    FoundationCheckApp.prototype.bind = function () {
      var self = this;
      this.el.querySelectorAll('[data-fc-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      this.el.querySelector('[data-fc-start]').addEventListener('click', function () {
        self.startedAt = Date.now();
        sessionStorage.setItem('fc_session_started', '1');
        self.track('foundation_check_started', {});
        self.showScreen('intro');
      });
      this.el.querySelector('[data-fc-capture-form]').addEventListener('submit', function (e) {
        e.preventDefault();
        self.submitCapture();
      });
      this.el.querySelector('[data-fc-intro-continue]').addEventListener('click', function () {
        self.startedAt = Date.now();
        sessionStorage.setItem('fc_session_started', '1');
        self.track('foundation_check_started', {});
        self.showQuestion(0);
      });
      this.el.querySelector('[data-fc-cta]').addEventListener('click', function () {
          var resultType = self.result ? self.result.resultType : null;
          var primaryTheme = (self.result && self.result.shown[0]) || null;
          var secondaryTheme = (self.result && self.result.shown[1]) || null;
          var formulaFlag = self.result ? self.result.formulaFlag : false;
          var consistencyFlag = self.result ? self.result.consistencyFlag : false;

          self.track('foundation_check_cta_clicked', {
            result_type: resultType,
            primary_theme: primaryTheme,
            secondary_theme: secondaryTheme,
            formula_flag: formulaFlag,
            consistency_flag: consistencyFlag
          });

          try {
            localStorage.setItem('fc_pending_attribution', JSON.stringify({
              ts: Date.now(),
              result_type: resultType,
              primary_theme: primaryTheme,
              secondary_theme: secondaryTheme,
              formula_flag: formulaFlag,
              consistency_flag: consistencyFlag,
              session_id: self.sessionId(),
              visitor_id: self.visitorId,
              device_class: self.deviceClass,
              entry_point: self.entryPoint,
              holdout: self.isHoldout,
              new_visitor: self.isNewVisitor,
              utm_source: self.utm.utm_source,
              utm_medium: self.utm.utm_medium,
              utm_campaign: self.utm.utm_campaign,
              landing_page: self.landingPage
            }));
          } catch (e) {}
        });

      window.addEventListener('foundation-check:open', function (e) {
        if (self.isHoldout) return;
        self.entryPoint = (e.detail && e.detail.entryPoint) || 'inline';
        self.open();
      });

      window.FoundationCheck = window.FoundationCheck || {};
      window.FoundationCheck.suppressed = false;
      window.FoundationCheck.suppressOverlay = function () { window.FoundationCheck.suppressed = true; };
      window.FoundationCheck.unsuppressOverlay = function () { window.FoundationCheck.suppressed = false; };
      window.FoundationCheck.open = function (entryPoint) {
        if (self.isHoldout) return;
        self.entryPoint = entryPoint || 'inline';
        self.open();
      };
      window.FoundationCheck.track = function (eventName, properties) {
        self.track(eventName, properties);
      };
    };

    FoundationCheckApp.prototype.assignHoldout = function () {
      var stored = localStorage.getItem('fc_holdout');
      if (stored === null) {
        var isHoldout = Math.random() * 100 < this.holdoutPercent;
        localStorage.setItem('fc_holdout', isHoldout ? '1' : '0');
        stored = isHoldout ? '1' : '0';
      }
      this.isHoldout = stored === '1';
    };

    FoundationCheckApp.prototype.suppressionActive = function () {
      if (this.isHoldout) return true;
      if (window.FoundationCheck && window.FoundationCheck.suppressed) return true;
      if (sessionStorage.getItem('fc_session_started') || sessionStorage.getItem('fc_session_completed')) return true;

      var completedAt = localStorage.getItem('fc_completed_at');
      if (completedAt) {
        var days = (Date.now() - parseInt(completedAt, 10)) / 86400000;
        if (days < this.cooldownDays) return true;
      }
      return false;
    };

    FoundationCheckApp.prototype.initTriggers = function () {
      var self = this;
      var pageLoadedAt = Date.now();
      var firedThisSession = sessionStorage.getItem('fc_overlay_fired');
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      function secondsOnPage() { return (Date.now() - pageLoadedAt) / 1000; }

      function eligibleToFire() {
        if (firedThisSession) return false;
        if (self.suppressionActive()) return false;
        return true;
      }

      async function cartHasItems() {
        try {
          var res = await fetch('/cart.js');
          var cart = await res.json();
          return (cart.item_count || 0) > 0;
        } catch (e) {
          return false;
        }
      }

      async function fire() {
        if (!eligibleToFire()) return;
        if (secondsOnPage() < self.exitIntentDelay) return;
        if (await cartHasItems()) return;
        firedThisSession = true;
        sessionStorage.setItem('fc_overlay_fired', '1');
        self.entryPoint = 'overlay';
        self.open();
      }

      if (!isMobile) {
        document.addEventListener('mouseout', function (e) {
          if (e.clientY > 0) return;
          if (e.relatedTarget || e.toElement) return;
          fire();
        });
      } else {
        var lastScrollY = window.scrollY;
        var maxDepthReached = 0;
        var viaBackButton = false;

        window.addEventListener('popstate', function () { viaBackButton = true; setTimeout(function () { viaBackButton = false; }, 500); });

        window.addEventListener('scroll', function () {
          var docHeight = document.documentElement.scrollHeight - window.innerHeight;
          var depthPct = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
          maxDepthReached = Math.max(maxDepthReached, depthPct);

          var scrollingUp = window.scrollY < lastScrollY;
          if (scrollingUp && maxDepthReached >= self.mobileScrollDepth && !viaBackButton) {
            fire();
          }
          lastScrollY = window.scrollY;
        }, { passive: true });
      }
    };

    FoundationCheckApp.prototype.resetState = function () {
        this.answers = {};
        this.currentIndex = -1;
        this.completed = false;
        this.result = null;
        this.startedAt = null;

        var form = this.el.querySelector('[data-fc-capture-form]');
        form.reset();
        form.hidden = false;
        this.el.querySelector('[data-fc-error]').hidden = true;
        this.el.querySelector('[data-fc-confirmation]').hidden = true;
        this.el.querySelector('[data-fc-submit]').disabled = false;

        this.updateProgressSegments(-1);
        this.showScreen('start');
      };

   FoundationCheckApp.prototype.open = function () {
      if (this.completed) {
        this.resetState();
      }
      this.overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      void this.overlay.offsetWidth;
      this.overlay.classList.add('fc-overlay--visible');

      this.track('foundation_check_viewed', { entry_point: this.entryPoint });
    };

    FoundationCheckApp.prototype.close = function () {
      var self = this;
      this.overlay.classList.remove('fc-overlay--visible');
      document.documentElement.style.overflow = '';
      var TRANSITION_MS = 350;
      setTimeout(function () {
        self.overlay.hidden = true;
      }, TRANSITION_MS);

      if (this.currentIndex >= 0 && this.currentIndex < QUESTIONS.length && !this.completed) {
        this.track('foundation_check_abandoned', {
          last_question_answered: this.currentIndex > 0 ? QUESTIONS[this.currentIndex - 1].id : null,
          time_spent_seconds: this.startedAt ? Math.round((Date.now() - this.startedAt) / 1000) : 0
        });
      }
    };

    FoundationCheckApp.prototype.showScreen = function (name) {
      Object.keys(this.screens).forEach(function (key) {
        this.screens[key].hidden = key !== name;
      }, this);
      this.progressWrap.hidden = (name === 'start' || name === 'intro');
    };

    FoundationCheckApp.prototype.showQuestion = function (index) {
      this.currentIndex = index;
      var q = QUESTIONS[index];
      this.showScreen('question');

      this.el.querySelector('[data-fc-question-count]').textContent = 'Question ' + (index + 1) + ' of ' + QUESTIONS.length;
      this.el.querySelector('[data-fc-question-text]').textContent = q.text;
      this.updateProgressSegments(index);

      var optionsWrap = this.el.querySelector('[data-fc-options]');
      optionsWrap.innerHTML = '';
      var self = this;
      q.options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fc-option';
        btn.textContent = opt.label;
        btn.addEventListener('click', function () { self.answer(q.id, opt.key); });
        optionsWrap.appendChild(btn);
      });
    };
    FoundationCheckApp.prototype.answer = function (questionId, key) {
      this.answers[questionId] = key;
      this.track('foundation_check_question_answered', { question_id: questionId, answer_key: key });

      if (this.currentIndex + 1 < QUESTIONS.length) {
        this.showQuestion(this.currentIndex + 1);
      } else {
        this.finish();
      }
    };

    FoundationCheckApp.prototype.finish = function () {
      this.completed = true;
      sessionStorage.setItem('fc_session_completed', '1');
      localStorage.setItem('fc_completed_at', String(Date.now()));

      var result = scoreAnswers(this.answers);
      this.result = result;
      this.updateProgressSegments(QUESTIONS.length - 1);
      this.renderResult(result);
      this.showScreen('result');

      var resultCopy = getResultCopy(result);

      this.track('foundation_check_completed', {
        result_type: result.resultType,
        primary_theme: result.shown[0] || null,
        secondary_theme: result.shown[1] || null,
        formula_flag: result.formulaFlag,
        consistency_flag: result.consistencyFlag,
        result_title: resultCopy.title,
        result_summary: resultCopy.summary
      });

      this.track('foundation_check_result_viewed', {
        result_type: result.resultType,
        primary_theme: result.shown[0] || null,
        secondary_theme: result.shown[1] || null,
        formula_flag: result.formulaFlag,
        consistency_flag: result.consistencyFlag
      });
    };

    FoundationCheckApp.prototype.renderResult = function (result) {
      var html = '';

      if (result.resultType === 'solid_ground') {
        html += '<h2 class="fc-result-header">' + SOLID_GROUND_HEADER + '</h2>';
        html += '<p class="fc-result-intro">' + SOLID_GROUND_BODY + '</p>';
      } else {
        html += '<h2 class="fc-result-header">' + GAPS_HEADER + '</h2>';
        html += '<p class="fc-result-intro">' + (result.shown.length === 2 ? INTRO_TWO : INTRO_ONE) + '</p>';
        result.shown.forEach(function (t, index) {
          var c = THEME_COPY[t];
          var iconHtml = c.icon ? '<span class="fc-icon">' + c.icon + '</span>' : '';

          var formattedIndex = ('0' + (index + 1)).slice(-2);
          var indexHtml = '<span class="fc-index">' + formattedIndex + '</span>';
          html += '<div class="fc-theme-block">'+ iconHtml + '<div class="block-text__wrapper"><h3>' + indexHtml +  c.heading + '</h3><p>' + c.body + '</p></div></div>';
        });
      }

      if (result.formulaFlag) {
        html += '<div class="fc-theme-block">' + '<p>' + FORMULA_BLOCK + '</p></div>';
      } else if (result.consistencyFlag) {
        html += '<div class="fc-theme-block">' + '<p>' + CONSISTENCY_LINE + '</p></div>';
      }

      html += '<p class="fc-medical-note">' + MEDICAL_NOTE + '</p>';

      this.el.querySelector('[data-fc-result-content]').innerHTML = html;

      var captureCopy = result.resultType === 'solid_ground' ? CAPTURE_SOLID : CAPTURE_GAPS;
      this.el.querySelector('[data-fc-capture-heading]').textContent = captureCopy.heading;
      this.el.querySelector('[data-fc-capture-body]').textContent = captureCopy.body;
      this.el.querySelector('[data-fc-capture-form]').hidden = false;
      this.el.querySelector('[data-fc-confirmation]').hidden = true;

      var nutrients = buildNutrientList(result.shown);
      var bridgeEl = this.el.querySelector('[data-fc-bridge-copy]');
      var attributionEl = this.el.querySelector('[data-fc-bridge-attribution]');
      if (nutrients.length > 0) {
        bridgeEl.textContent = BRIDGE_STANDARD.replace('{nutrients}', joinNutrients(nutrients));
        attributionEl.hidden = false;
      } else {
        bridgeEl.textContent = BRIDGE_FALLBACK;
        attributionEl.hidden = true;
      }
    };

    FoundationCheckApp.prototype.submitCapture = function () {
      var self = this;
      var form = this.el.querySelector('[data-fc-capture-form]');
      var firstName = form.querySelector('[data-fc-field="first_name"]').value.trim();
      var email = form.querySelector('[data-fc-field="email"]').value.trim();
      var errorEl = this.el.querySelector('[data-fc-error]');
      errorEl.hidden = true;

      if (!firstName || !email) return;

      var submitBtn = this.el.querySelector('[data-fc-submit]');
      submitBtn.disabled = true;

      var result = this.result;
      var properties = {
        result_type: result.resultType,
        primary_theme: result.shown[0] || '',
        secondary_theme: result.shown[1] || '',
        formula_flag: result.formulaFlag,
        consistency_flag: result.consistencyFlag,
        entry_point: this.entryPoint
      };

      this.postToKlaviyo(firstName, email, properties)
        .then(function () {
          form.hidden = true;
          self.el.querySelector('[data-fc-confirmation]').hidden = false;
          self.track('foundation_check_email_submitted', properties);
        })
        .catch(function (err) {
          console.error('[FoundationCheck] Klaviyo submit failed', err);
          errorEl.hidden = false;
          self.track('foundation_check_email_error', { message: String(err) });
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    };

    FoundationCheckApp.prototype.postToKlaviyo = async function (firstName, email, properties) {
      if (!this.companyId || !this.listId) {
        throw new Error('Missing Klaviyo company_id or list_id — set them in section settings.');
      }

      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', Object.assign({
          $email: email,
          $first_name: firstName
        }, properties)]);
      }

      var res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + this.companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'revision': '2025-01-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: firstName,
                    properties: properties,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: this.listId } }
            }
          }
        })
      });

      if (!res.ok) throw new Error('Klaviyo subscribe failed: ' + res.status);
      return true;
    };

    FoundationCheckApp.prototype.track = function (eventName, properties) {
      var payload = Object.assign({
        session_id: this.sessionId(),
        visitor_id: this.visitorId,
        device_class: this.deviceClass,
        entry_point: this.entryPoint,
        holdout: this.isHoldout,
        new_visitor: this.isNewVisitor,
        utm_source: this.utm.utm_source,
        utm_medium: this.utm.utm_medium,
        utm_campaign: this.utm.utm_campaign,
        landing_page: this.landingPage
      }, properties || {});

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));

      if (window._learnq) {
        window._learnq.push(['track', eventName, payload]);
      }
    };

    FoundationCheckApp.prototype.sessionId = function () {
      var id = sessionStorage.getItem('fc_session_id');
      if (!id) {
        id = 'fc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
        sessionStorage.setItem('fc_session_id', id);
      }
      return id;
    };

    return FoundationCheckApp;
  }());

  class FoundationCheckElement extends HTMLElement {
    connectedCallback() {
      this.app = new FoundationCheckApp(this);
    }
    disconnectedCallback() {}
  }

  customElements.define('foundation-check-app', FoundationCheckElement);
})();

  } catch(e) { console.error(e); }
})();
})();
